import BedroomColor from './BedroomColour.svg';
import BedroomDark from './BedroomDark.svg';
import BedroomLight from './BedroomLight.svg';
export const bedroom = { color: BedroomColor, dark: BedroomDark, light: BedroomLight };
//# sourceMappingURL=index.js.map